export default __webpack_public_path__ + "static/media/stroke-1-copy-3.0a85c3d1.svg";